export default store => {
  return {
    path: "standards",
    getComponent(nextState, cb) {
      const comp = require("./StandardV2").default;
      cb(null, comp);
    },
  };
};
